const adminAppTags = {
  actions: {
    add: 'Add tag',
    delete: 'Delete',
    open: 'Open actions for {{name}}',
    rename: 'Rename',
  },
  columnSelector: {
    label: 'Choose app tag list columns',
    trigger: 'Columns',
  },
  createDialog: {
    confirm: 'Create tag',
    title: 'Add tag',
  },
  deleteDialog: {
    confirm: 'Delete',
    noApps: 'No linked apps.',
    subtitle: 'Deleting this tag will remove it from linked apps.',
    subtitleWithName: 'Deleting tag "{{name}}" will remove it from linked apps.',
    title: 'Delete tag',
  },
  description: 'Categorize apps for easier filtering and management.',
  dialog: {
    cancel: 'Cancel',
    close: 'Close dialog',
  },
  empty: 'No data',
  errors: {
    duplicateName: 'This tag already exists. Use a different name.',
    loadFailed: 'Try again later, or check whether this admin still has access.',
    loadTitle: 'Failed to load app tags',
    loadWithDetail: 'Backend response: {{detail}}',
    notFound: 'This tag does not exist or has already been deleted.',
    operationFailed: 'Operation failed. Try again later.',
    permissionDenied: 'This admin does not have permission to modify app tags.',
  },
  filters: {
    searchLabel: 'Search app tags',
    searchPlaceholder: 'Search app tags',
  },
  feedback: {
    createSuccess: 'Tag created',
    deleteSuccess: 'Tag deleted',
    updateSuccess: 'Tag saved',
  },
  form: {
    nameLabel: 'Tag name',
    namePlaceholder: 'Enter tag name',
  },
  pagination: {
    next: 'Next page',
    pageSize: '{{count}} / page',
    previous: 'Previous page',
  },
  renameDialog: {
    confirm: 'Save',
    title: 'Rename tag',
  },
  retry: 'Retry',
  sort: {
    createdAtAsc: 'Sort by created time ascending',
    createdAtDesc: 'Sort by created time descending',
    updatedAtAsc: 'Sort by updated time ascending',
    updatedAtDesc: 'Sort by updated time descending',
  },
  table: {
    actions: 'Actions',
    appCount: 'Apps',
    createdAt: 'Created at',
    createdBy: 'Created by',
    name: 'App tag',
    updatedAt: 'Last updated',
    updatedBy: 'Last updated by',
  },
  title: 'App tags',
  validation: {
    nameRequired: 'Enter a tag name.',
  },
  workspaceLabel: 'App tags workspace',
}

export default adminAppTags
